import React from 'react';
import styled, { css } from 'styled-components';

// Locals
import theme from '~/common/styled/theme';

const Loading = props => <Loader {...props} src={theme.images.loading} />;

const Loader = styled.img`
  width: 50px;
  height: 50px;
  ${props =>
    props.small &&
    css`
      width: 20px;
      height: 20px;
    `};
`;

export default Loading;
